<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="FM-Epigraph-non-verse-fmepi"><span class="ePub-I">Not everything that is faced can be changed, but nothing can be changed until it is faced.</span></p>
<p class="FM-Epigraph-Source-fmeps">—J<span class="ePub-SC">AMES</span> B<span class="ePub-SC">ALDWIN</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?f9fdaa16